import { Directive, HostListener, input, output } from '@angular/core';

@Directive({
  selector: '[coreScrollToBottom]',
})
export class ScrollToBottomDirective {
  maxLimit = input(Infinity);
  currentCount = input(0);
  scrolledToBottom = output<void>();

  @HostListener('scroll', ['$event'])
  onScroll(event: Event): void {
    const target = event.target as HTMLElement;
    const atBottom =
      Math.floor(target.scrollHeight - target.scrollTop) ===
      Math.floor(target.clientHeight);

    if (atBottom && this.currentCount() < this.maxLimit()) {
      this.scrolledToBottom.emit();
    }
  }
}
